import { render, staticRenderFns } from "./EscalationMatrixForm.vue?vue&type=template&id=3fa30bf6&scoped=true"
import script from "./EscalationMatrixForm.vue?vue&type=script&lang=js"
export * from "./EscalationMatrixForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EscalationMatrixForm.vue?vue&type=style&index=1&id=3fa30bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa30bf6",
  null
  
)

export default component.exports